import { configureStore } from '@reduxjs/toolkit';
import AuthenticateSlice from '../features/AuthenticateSlice';

export const store = configureStore({
  reducer: {
    authenticate: AuthenticateSlice
  },
});
